import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'

const ServiceContract = ({ globalData }) => {
    return (
        <Container>
            <Row>
                <Col md={12} className="mt-2">

                    <div className="content-main-div">
                        <h1 className="content-heading">
                            Protect Your Investment with a Comprehensive Car Service Contract in UAE
                        </h1>
                        <ul>
                            <li><p className="content-paragraph">A car service contract, also known as an extended warranty, is a type of protection plan that covers the cost of repairs or replacement parts for your vehicle after the manufacturer's warranty has expired. It provides peace of mind knowing that unexpected repair bills will be covered, which can help you avoid financial stress.
                            </p></li>

                            <li><p className="content-paragraph">At Open Bonnet, we understand that owning a car can be expensive, and unexpected repairs can take a toll on your wallet. That's why we offer a range of car service contracts to help you protect your investment and keep your vehicle running smoothly for years to come.
                            </p></li>

                            <li><p className="content-paragraph">Our car service contracts are designed to provide comprehensive coverage for your vehicle, including engine and transmission repairs, electrical system repairs, <a className='paragraph-link' href={`/services/${globalData.locationData?.data?.EmirateAreaSlug ||
                                "dubai"
                                }/mobile-mechanic`}>Mobile Mechanics</a>, and more. We offer a variety of plans to choose from, so you can select the coverage that best suits your needs and budget.
                            </p></li>

                            <li><p className="content-paragraph">When you purchase a car service contract from Open Bonnet, you can rest assured that you are getting the best possible coverage at an affordable price. Our team of experts will work with you to ensure that you understand the terms and conditions of your contract, so there are no surprises when it comes time to make a claim.
                            </p></li>

                            <li><p className="content-paragraph">In addition to our comprehensive coverage, we also offer excellent customer service and support. Our team is available to answer any questions you may have about your car service contract and to provide guidance and assistance throughout the claims process.
                            </p></li>

                            <li><p className="content-paragraph">Don't let unexpected repair bills ruin your day. Invest in a car service contract from Open Bonnet today and enjoy the peace of mind that comes with knowing you are protected. Contact us to learn more about our car service contract options and to get a quote.
                            </p></li>
                        </ul>
                    </div>

                </Col>
            </Row>
        </Container >
    )
}

export default ServiceContract
